<section id="pageCover" class="row">
    <img src="../../../assets/images/contactCover.png" alt="" class="pageCover">
    <!--<div class="row pageTitle">Projects</div>-->
    <div class="row pageBreadcrumbs">
        <!--<ol class="breadcrumb">
            <li><a href="index.html">home</a></li>
            <li class="active">Projects</li>
        </ol>-->
    </div>
</section>

<section id="contacts" class="row">
    <div class="container">
        <div class="row">
            <div class="row m0">
                <div class="col-sm-8">
                    <div class="row m0 commentForm">
                        <h3>{{'Career' | translate}}</h3>
                        <form class="row m0" id="contactForm" method="post" name="contact" action="Request_process.php">

                            <div class="col-sm-6 p0 commenterInfoInputs">
                                <div class="row m0">


                                    <div class="input-group">
                                        <span class="input-group-addon"><i class="fa fa-envelope"></i></span>
                                        <input type="email" class="form-control" name="email" id="email" placeholder="{{'e-mail' | translate}}">
                                    </div>
                                    <div class="input-group">
                                        <span class="input-group-addon"><i class="fa fa-briefcase"></i></span>
                                        <input type="text" name="jobtitle" id="jobtitle" class="form-control" placeholder="{{'JobTitle' | translate}}">
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6 p0">
                                <div class="row m0">

                                    <div class="input-group">
                                        <span class="input-group-addon"><i class="fa fa-user"></i></span>
                                        <input type="text" name="name" id="name" class="form-control" placeholder="{{'name' | translate}}">
                                    </div>
                                    <div class="input-group">
                                        <span class="input-group-addon"><i class="fa fa-phone"></i></span>
                                        <input type="tel" name="Mobile" id="Mobile" class="form-control" placeholder="05XXXXXXXX">
                                    </div>

                                </div>
                            </div>
                            <div class="row m0">

                                <div class="input-group">
                                    <span class="input-group-addon"><i class="fa fa-upload"></i></span>
                                    <input type="file"
                                           name="attachmentFile" id="attachmentFile"
                                           class="form-control">
                                </div>
                            </div>
                            <div class="row m0">

                                <div class="input-group">
                                    <textarea placeholder="{{'Message' | translate}}" name="message" id="message" class="form-control"></textarea>
                                </div>
                            </div>
                            <div class="row m0 ">

                                <div class="col-sm-6"></div>
                                <div class="col-sm-6">
                                    <button class="btn btn-default" type="submit">{{'send' | translate}} </button>
                                </div>
                            </div>
                        </form>
                        <div id="success">
                            <span class="green textcenter">
                                <p>{{'successfully' | translate}}</p>
                            </span>
                        </div>
                        <div id="error">
                            <span>
                                <p>{{'wrong' | translate}}</p>
                            </span>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    </div>
</section>